export default __webpack_public_path__ + "static/media/vkycOptionScreen@2x.30ab1b3c.png";